import { axiosFactory, axiosPostFactory, axiosFormFactory } from './axios-factory'
export default {
    // 学段获取学科
    subjectList: (params) => axiosFactory({
        url: 'res/listSubject',
        params,
        // ?phaseCode=03
    }),
}